<template>
  <div class="videos" :style="wrap_style">
    <div class="title" v-if="videos && videos.length>0 && !info.actVideosRecommend.hide_title">
      无限好剧等你来看!
      <div class="more" @click="more" v-show="!disable_click">更多&gt;</div>
    </div>
    <div class="main">
      <div class="row">
        <div v-for="(item,index) in videos.slice(0,3)" class="video" @click="click_video(item)">
          <img class="cover" :src="item.img">
          <div class="name" v-if="!info.actVideosRecommend.hide_name">{{item.name}}</div>
        </div>
      </div>
      <div class="row" v-if="videos.length > 3">
        <div v-for="(item,index) in videos.slice(3,6)" class="video" @click="click_video(item)">
          <img class="cover" :src="item.img">
          <div class="name" v-if="!info.actVideosRecommend.hide_name">{{item.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

  import click_handler from '../../tools/mgtv/click'
  import to_casher from '../../tools/mgtv/casher'
  import {openLink} from '../../tools/mgtv/link'
  import download from '../../tools/mgtv/downapp'
  import {getJSON} from '../../api/myaxios'

  export default {
    name: 'ActVideosRecommend',
    props: {
      info: {
        type: Object,
        default: function () {
          return {
            "actVideosRecommend": {
              "style": {
                color: 'red',
                padding: '0 0.4rem'
              },
              "disable_click": false, //默认是false 是否可以点击
              "hide_title": false,
              "hide_name": false
            }
          }
        }
      }
    },
    data() {
      return {
        gact: window.gact,
        videos: []
      }
    },
    computed: {
      wrap_style() {
        return this.info && this.info.actVideosRecommend && this.info.actVideosRecommend.style
      },
      disable_click() {
        return !!this.info.actVideosRecommend.disable_click;
      }
    }
    ,
    methods: {
      get_videos() {
        getJSON('//vipact3.api.mgtv.com/api/v1/act/banner', {}).then(res => {
          if (res && res.ret === 0) {
            if (res.data.list.videos) {
              this.videos = res.data.list.videos;
            }
          }
        })
      }
      ,
      click_video(item) {
        if (this.info.actVideosRecommend.disable_click) {
          return;
        }
        click_handler('热门视频-点击' + item.name, function () {
          setTimeout(() => {
            openLink(item.url);
          }, 500);
        }, {
          need_login: false,
          need_act: false,
          need_vip: false
        })
      }
      ,
      more() {
        click_handler('热门视频-更多', function () {
          download();
        }, {
          need_login: false,
          need_act: false,
          need_vip: false
        })
      }
    }
    ,
    created() {
      this.get_videos();
    }
    ,
    mounted() {

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
  @import "../../share/mixins.styl"
  .videos
    position relative
    width 7.5rem

    .title
      width 100%
      text-align center
      font-size .3rem
      height .34rem
      line-height .34rem
      font-weight bold
      .more
        position absolute
        right .2rem
        display inline-block
        height .34rem
        font-size .26rem
        line-height .34rem
    .main
      width 100%
      position relative
      .row
        display flex
        justify-content space-between
        .video
          width 2.18rem
          text-align center
          display inline-block
          margin-top .1rem
          position relative
        .cover
          display block
          margin 0 auto
          width 2.02rem
        .name
          width 2.18rem
          font-size .26rem
          margin-top .04rem
          ellipsis()

</style>



// WEBPACK FOOTER //
// src/components/ConfigUI/ActVideosRecommend.vue